import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import SelectBox from '@components/SelectBox';
import { useTranslation } from 'next-i18next';
import _findIndex from 'lodash/findIndex';
import _get from 'lodash/get';

const AdditionalOptions = ({
  isShowTitle = true,
  custom_options,
  selected_options,
  onSelectCustomOption = options => {},
}) => {
  const { t } = useTranslation('common');
  return (
    <>
      {isShowTitle ? <Typography gutterBottom>{t('additional-options')}:</Typography> : null}
      {custom_options && custom_options.length > 0
        ? custom_options.map(({ title, values, is_required, key }, i) => {
            let selectedValue = '';
            let formattedValues = [];
            if (!is_required) {
              formattedValues.push({
                value: '',
                label: '',
              });
            }
            const valuesArr = values.map(option => {
              if (!selectedValue && option.is_default) {
                selectedValue = option.key;
              }
              return {
                value: option.key,
                label: option.title,
              };
            });
            const options = formattedValues.concat(valuesArr);
            if (selected_options) {
              const foundIndex = _findIndex(selected_options, { key });
              if (foundIndex > -1) {
                const value_key = _get(selected_options, `${foundIndex}.value_key`);
                selectedValue = value_key;
              }
            }
            return (
              <div key={i}>
                <SelectBox
                  value={selectedValue}
                  required={is_required}
                  label={title}
                  options={options}
                  callback={value_key => {
                    let newSelectedOptions = [];
                    let value_title = '';
                    const foundIndexValue = _findIndex(values, { key: value_key });
                    if (foundIndexValue > -1) {
                      value_title = _get(values, `${foundIndexValue}.title`);
                    }
                    const newSelectedValue = {
                      key,
                      title,
                      value_key,
                      value_title,
                    };
                    if (selected_options && selected_options.length > 0) {
                      newSelectedOptions = selected_options;
                      const foundSelectedIndex = _findIndex(selected_options, { key });
                      if (foundSelectedIndex > -1) {
                        newSelectedOptions[foundSelectedIndex] = newSelectedValue;
                      } else {
                        newSelectedOptions.push(newSelectedValue);
                      }
                    } else {
                      newSelectedOptions.push(newSelectedValue);
                    }
                    onSelectCustomOption(newSelectedOptions);
                  }}
                />
              </div>
            );
          })
        : null}
    </>
  );
};

AdditionalOptions.propTypes = {
  isShowTitle: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  custom_options: PropTypes.array,
};

export default AdditionalOptions;
